import type { CSSProperties } from 'react';

export const LOGIN_COLORS = {
  primary: '#0066B2',
  primaryHover: '#005494',
  primaryLight: '#E8F2FA',
  primaryMuted: '#B3D1E8',
  pageBg: '#FFFFFF',
  /** Literal white — do not use Tailwind `bg-white`/`text-white` (those map to theme `--white`, which is dark in dark mode). */
  pureWhite: '#FFFFFF',
  cardShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
  inputBorder: '#D0D5DD',
  inputBg: '#FFFFFF',
  inputText: '#252728',
  ssoButtonBorder: '#EAEAEA',
  textPrimary: '#101828',
  textSecondary: '#252728',
  textMuted: '#667085',
  textLabel: '#344054',
  textPlaceholder: '#98A2B3',
  divider: '#CACBCB',
  heroBg: '#0B0D10',
  heroTitle: '#FBFBFB',
  heroTagline: '#C7CBD1',
  heroGradientFrom: '#0066CC',
  heroGradientTo: '#00C5A1',
} as const;

/**
 * Overrides for the design-system CSS variables consumed by shared `core`/`ui-kit`
 * components (surface, emphasis, popover, accent, border). The auth hero page always
 * renders light regardless of the app-wide theme preference, so any themed component
 * placed inside it (e.g. `LanguageSelector`) needs these reasserted locally — otherwise
 * a user with dark mode saved from a previous session sees a dark trigger/popover
 * floating on the white login card.
 */
export const LOGIN_FORCED_LIGHT_VARS = {
  '--surface': '0, 0%, 100%',
  '--high-emphasis': '190, 10%, 12%',
  '--medium-emphasis': '0, 0%, 40%',
  '--popover': '0, 0%, 100%',
  '--popover-foreground': '190, 10%, 12%',
  '--accent': '210, 10%, 96%',
  '--accent-foreground': '190, 10%, 12%',
  '--border': '220, 7%, 91%',
} as CSSProperties;
